import { Box, Typography, useTheme } from '@mui/material';
import { useGetRetrieveChunk } from 'apis/business/setting/knowledgeBase/hook';
import Button from 'components/Common/Button';
import Input from 'components/Common/Input';
// import Slider from 'components/Common/Slider';
import { useBusiness } from 'providers/context/BusinessProvider';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

export default function RetrievalTesting({ isRenderInModal = false }: { isRenderInModal?: boolean }) {
  const theme = useTheme();
  const { knowledgeBaseId } = useParams();
  const { selectedWorkspace } = useBusiness();
  const [submitted, setSubmitted] = useState<any | null>(null);
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      similarity_threshold: 0.2,
      vector_similarity_weight: 0.3
    }
  });

  const { data: retrieveChunk } = useGetRetrieveChunk(submitted, {
    queryKey: ['retrieveChunk', selectedWorkspace, knowledgeBaseId, submitted],
    enabled: Boolean(selectedWorkspace && knowledgeBaseId && submitted)
  });

  const onSubmit = (data?: any) => {
    setSubmitted(data ?? watch());
  };

  return (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='center' marginBottom={3}>
        <Typography variant='h6'>Retrieval Testing</Typography>
        {/* <Box display='flex' alignItems='center'>
          <Select
            sx={{ width: '275px' }}
            name='weight'
            label='Keywords similarity weight'
            control={control}
            options={[
              {
                value: 'BAAI/bge-reranker-v2-m3',
                label: 'BAAI/bge-reranker-v2-m3'
              }
            ]}
          />
          <IconButton color='primary'>
            <MdOutlineSettings />
          </IconButton>
        </Box> */}
      </Box>
      <Box
        bgcolor={theme.palette.background.paper}
        padding={3}
        borderRadius='4px'
        component='form'
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* TODO- @need to work later */}
        {/* <Grid container spacing={6}>
          <Grid size={4}>
            <Typography variant='body1' fontWeight={500} color='secondary'>
              Keyword Similarity Weight
            </Typography>
            <Slider
              name='similarity_threshold'
              control={control}
              min={0}
              max={1}
              step={0.1}
              defaultValue={0.2}
            />
          </Grid>
          <Grid size={4}>
            <Typography variant='body1' fontWeight={500} color='secondary'>
              Similarity Threshold
            </Typography>
            <Slider
              name='vector_similarity_weight'
              control={control}
              min={0}
              max={1}
              step={0.1}
              defaultValue={0.2}
            />
          </Grid>
        </Grid> */}
        <Input name='content' label='Test Text' control={control} fullWidth />
        <Button onClick={() => onSubmit()} sx={{ marginTop: '24px', display: 'block', marginLeft: 'auto' }}>
          Testing
        </Button>
      </Box>
      {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <MdOutlineIndeterminateCheckBox color='#4B22A8' fontSize={24} />
          <Typography fontWeight={500} variant='body1' color='secondary'>
            0/0 Files Selected
          </Typography>
        </Box> */}
      <Box height={isRenderInModal ? '300px' : '100%'} overflow='auto'>
        {retrieveChunk?.data?.map((chunk: any, index: number) => (
          <Box bgcolor={theme.palette.background.paper} padding={3} borderRadius='4px' marginTop={3} gap={0.5}>
            <Box border='1px solid #ECECEC' padding={3} borderRadius={0.5} mt={3} key={index}>
              <Box display='flex' alignItems='center' gap={3} borderBottom='1px solid #ECECEC' pb={3}>
                <Typography>{(chunk?.similarity * 100)?.toFixed(2)} Hybrid Similarity</Typography>
                <Typography>{(chunk?.term_similarity * 100)?.toFixed(2)} Term Similarity</Typography>
                <Typography>{(chunk?.vector_similarity * 100)?.toFixed(2)} Vector Similarity</Typography>
              </Box>
              <Box display='flex' gap={3} mt={3}>
                {/* <img
                  alt='file'
                  src='https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/horizontal-wiki_ver_1.png'
                  width={144}
                  height={84}
                /> */}
                <Typography sx={{ wordBreak: 'break-word' }}>{chunk?.content_with_weight}</Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
}
